// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Motivations-Sprüche im ruhigen Stark-&-Stabil-Ton: leise, stetig, ohne Drill.
export const SPRUECHE: string[] = [
  "Stabilität wächst leise – Satz für Satz.",
  "Kleine Schritte, tiefe Wurzeln.",
  "Kraft ist kein Sprint, Kraft ist ein Garten.",
  "Heute gepflanzt, morgen getragen.",
  "Dranbleiben zählt mehr als Draufpacken.",
  "Was langsam wächst, hält Stürmen stand.",
  "Dein Tempo ist das richtige Tempo.",
  "Auch der Wald wurde Baum für Baum stark.",
  "Ein ruhiges Training trägt weiter als ein wildes.",
  "Stille Arbeit, sichtbare Stärke.",
  "Der Weg trägt, weil du ihn regelmäßig gehst.",
  "Geduld ist auch ein Muskel.",
  "Jede Wiederholung ist ein leises Versprechen an dich.",
  "Stark ist, wer wiederkommt.",
  "Gut verwurzelt wackelt nichts.",
  "Dein Rücken merkt sich jede gute Woche.",
]

export function randomSpruch(): string {
  return SPRUECHE[Math.floor(Math.random() * SPRUECHE.length)]
}
